import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  FormInstance,
  Input,
  List,
  Space,
  Typography,
} from "antd";
import React, { Fragment, useEffect, useState } from "react";

import styled from "@emotion/styled";
import UploadImages from "components/UploadImages";
import { allowFileExtensionsImage } from "config";

interface VariationOptionFormProps {
  name: number;
  form: FormInstance;
  skuItem: VariationChoice[];
  variants?: VariantsInput;
  is_guid: boolean;
  is_inventory: boolean;
}

const VariationOptionForm: React.FC<VariationOptionFormProps> = ({
  name,
  variants,
  skuItem,
  is_guid,
  is_inventory,
}) => {
  const [imgaeName, setImageName] = useState<string[]>([]);

  useEffect(() => {
    if (variants) {
      console.log("variants-->", variants);
      let newImageName: string[] = [];
      variants.forEach((item) => {
        item.items.forEach((item) => {
          newImageName.push(item.name);
        });
      });
      //console.log(newImageName);
      setImageName(newImageName);
    }
  }, [variants]);

  return (
    <>
      <Form.List name={[name, "items"]}>
        {(fields, { add, remove }) => (
          <Fragment key={name}>
            {fields.map((field, index) => (
              <List.Item key={index} style={{ marginBottom: 24 }}>
                <WrapperForm>
                  <WrapFormRow>
                    <WrapFormCol>
                      <Form.Item
                        {...field}
                        label="ตัวเลือก"
                        name={[field.name, "name"]}
                        className="form-varation-name"
                        rules={[
                          {
                            required: true,
                            message: "กรุณากรอกชื่อตัวเลือก",
                          },
                        ]}
                        style={{ width: 550 }}
                      >
                        <Input
                          style={{ marginLeft: 5 }}
                          className="form-varation-name__input"
                          size="small"
                          onChange={(e) => {
                            const newImageName = [...imgaeName];
                            newImageName[index] = e.target.value;
                            setImageName(newImageName);
                          }}
                        />
                      </Form.Item>
                    </WrapFormCol>

                    <WrapFormCol>
                      <Form.Item
                        {...field}
                        label="รหัสสินค้า"
                        name={[field.name, "product_sku_code"]}
                        className="form-varation-name"
                        rules={[
                          {
                            required: false,
                            message: "กรุณากรอกรหัสสินค้า",
                          },
                        ]}
                        style={{ width: 250, marginLeft: 10 }}
                      >
                        <Input
                          // style={{ marginLeft: 5 }}
                          className="form-varation-name__input"
                          size="small"
                          autoComplete="off"
                        />
                      </Form.Item>
                    </WrapFormCol>
                    {/* <WrapFormCol2>
                      <Form.Item
                        {...field}
                        label="กำลังการผลิตต่อวัน"
                        name={[field.name, "product_capacity"]}
                        className="form-varation-name"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "กรุณากรอกกำลังการผลิตต่อวัน",
                        //   },
                        // ]}
                        style={{ width: 250 }}
                      >
                        <Input
                          style={{ marginLeft: 5 }}
                          className="form-varation-name__input"
                          size="small"
                          type="number"
                          onChange={(e) => {
                            // const newImageName = [...imgaeName];
                            // newImageName[index] = e.target.value;
                            // setImageName(newImageName);
                          }}
                        />
                      </Form.Item>
                      <WrapperPriceText>
                        <Typography.Text style={{ textAlign: "center" }}>
                          ชิ้น
                        </Typography.Text>
                      </WrapperPriceText>
                    </WrapFormCol2> */}
                  </WrapFormRow>

                  <BinWrapper>
                    <DeleteOutlined
                      style={{ fontSize: 16 }}
                      onClick={() => remove(field.name)}
                    />
                  </BinWrapper>
                </WrapperForm>
                {!is_inventory === true && (
                <WrapFormCol>
                  <div style={{ display: "flex", flexDirection: "row", }} >
                  <Form.Item
                    {...field}
                    label="วันหมดอายุนับจากวันที่ซื้อ"
                    name={[field.name, "expire_date_amount"]}
                    className="form-varation-name"
                    rules={[
                      {
                        required: false,
                        message: "กรุณากรอกวันหมดอายุนับจากวันที่ซื้อ",
                      },
                    ]}
                    style={{ width: 350 }}
                  >
                    <Input
                      // style={{ marginLeft: 5 }}
                      className="form-varation-name__input"
                      size="small"
                      autoComplete="off"
                      placeholder="วันหมดอายุนับจากวันที่ซื้อ"
                    />
                  </Form.Item>
                  <Typography.Text style={{ textAlign: "center", marginLeft: 10, marginTop: 7 }}>
                    วัน
                  </Typography.Text>
                  </div>
                </WrapFormCol>
                )}
                {is_inventory === true && (
                <WrapFormCol>
                  <div style={{ display: "flex", flexDirection: "row", }} >
                      จำนวนสินค้าคงเหลือ: <Typography.Text style={{ marginLeft: 10, fontWeight: "" }}>{skuItem[index]?.qty_onhand || 0}</Typography.Text>
                      <Typography.Text style={{ marginLeft: 10, fontWeight: "" }}>ชิ้น</Typography.Text>
                  </div>
                </WrapFormCol>
                )}
              </List.Item>
            ))}

            <Space
              style={{ display: "flex", marginBottom: 8, marginLeft: 65 }}
              align="baseline"
            >
              <Form.Item>
                <Button
                  type="dashed"
                  block
                  icon={<PlusOutlined />}
                  style={{
                    width: 210,
                  }}
                  onClick={() => add()}
                >
                  เพิ่มตัวเลือก
                </Button>
              </Form.Item>
            </Space>

            {/* // list upload */}

            <WrapperUpload>
              {fields.map((field, index) => (
                <List.Item key={index} style={{}}>
                  <WrapperImage key={field.key}>
                    <Form.Item {...field} name={[field.name, "image_id"]}
                      rules={[
                        {
                          required: false,
                          message: "กรุณาเลือกรูปภาพ",
                        },
                      ]}
                    >
                      <UploadImages allowFileExtensions={allowFileExtensionsImage}  maximumUploadItems={1} />
                    </Form.Item>
                    <TextWrapper>
                      <Typography.Text style={{ textAlign: "center", marginTop: 10 }}>
                        {imgaeName[index]}
                      </Typography.Text>
                    </TextWrapper>
                  </WrapperImage>
                </List.Item>
              ))}
            </WrapperUpload>
          </Fragment>
        )}
      </Form.List>
    </>
  );
};

export default VariationOptionForm;

const BinWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -20px;
`;

const WrapperUpload = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  white-space: wrap;
  margin-bottom: 30px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
  margin-top: -20px;
`;

const WrapperForm = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

const WrapperImage = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrapFormRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const WrapFormCol = styled.div`
  flex: 1;
  width: 100%;
`;

const WrapFormCol2 = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: flex-end;
  flex-direction: row;
  margin-right: 50px;
  align-items: center;
`;

const WrapperPriceText = styled.div`
  margin-left: 10px;
  margin-bottom: 25px;
`;
